/**
 * Enums pour les services IA
 */

/**
 * Langues supportées par les services IA
 */
export enum SupportedLanguage {
  FR = 'fr',
  EN = 'en',
  ES = 'es',
  DE = 'de',
}

/**
 * Type de contenu généré par l'IA
 */
export enum AIContentType {
  QUIZ = 'quiz',
  CLOZE_QUIZ = 'cloze_quiz',
  SUMMARY = 'summary',
  EXERCISE = 'exercise',
  QA = 'qa',
}

/**
 * Difficulté pour les exercices
 */
export enum DifficultyLevel {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard',
}

/**
 * Statut de traitement IA
 */
export enum AIProcessingStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PROCESSING = 'processing',
}
